module.exports = __webpack_public_path__ + "img/cats1.165e528e.jpg";